export enum ProductTypeEnum {
    ge = "ge",
    gx = "gx",
    snp = "snp",
    cnv = "cnv",
    microbe = "microbe",
    microrna = "microrna"
}
